import { createContext, useContext, useState, useMemo } from "react";

const FilterContext = createContext();

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return `${parseInt(day, 10)}-${months[parseInt(month, 10) - 1]}-${year}`;
};

export const FilterProvider = ({ children }) => {
  const currentDate = new Date().toISOString().split("T")[0];
  const [filters, setFilters] = useState({
    startDate: currentDate,
    endDate: currentDate,
  });

  const formattedFilters = useMemo(() => {
    const formattedStartDate = formatDate(filters.startDate);
    const formattedEndDate = formatDate(filters.endDate);
    const dateRange =
      formattedStartDate && formattedEndDate
        ? `${formattedStartDate}-${formattedEndDate}`
        : `${formatDate(currentDate)}-${formatDate(currentDate)}`;
    return {
      formattedStartDate,
      formattedEndDate,
      dateRange,
    };
  }, [filters.startDate, filters.endDate, currentDate]);

  const isDefaultDate = useMemo(() => {
    return filters.startDate === currentDate && filters.endDate === currentDate;
  }, [filters.startDate, filters.endDate, currentDate]);

  const updateFilters = (newFilters) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  };

  const clearFilters = () => {
    setFilters({
      startDate: currentDate,
      endDate: currentDate,
    });
  };

  return (
    <FilterContext.Provider
      value={{
        filters,
        formattedFilters,
        updateFilters,
        clearFilters,
        isDefaultDate,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error("useFilterContext must be used within a FilterProvider");
  }
  return context;
};
